import { render } from "./UpdateSuccess.vue?vue&type=template&id=d3a6f770"
import script from "./UpdateSuccess.vue?vue&type=script&lang=js"
export * from "./UpdateSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__